/* ============
 * Bill Type Transformer
 * ============
 *
 * The transformer for the billTypes.
 */

import Transformer from './transformer';

export default class addressTypeTransformer extends Transformer {

  static fetch(addressType) {
    return {
      id: addressType.id,
      name: addressType.name,
    };
  }

  static send(addressType) {
    return {
      id: addressType.id,
      name: addressType.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/addressType.js